export default "__VITE_ASSET__BiwTkUhF__"